var _style, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:2;}\r\n\t.st2{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13,12V20c0,0.8,0.9,1.3,1.6,0.9l6-4c0.6-0.4,0.6-1.3,0-1.7l-6-4C13.9,10.7,13,11.2,13,12z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.1,25.5c-9.7,0.7-14.5,0.7-24.2,0c-1.1-0.1-2.2-1.1-2.3-2.2c-0.8-5.8-0.8-8.7,0-14.5 c0.2-1.1,1.2-2.2,2.3-2.2c9.7-0.7,14.5-0.7,24.2,0c1.1,0.1,2.2,1.1,2.3,2.2c0.8,5.8,0.8,8.7,0,14.5C30.3,24.4,29.2,25.4,28.1,25.5z "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.a3e44425fddbc57923c3b51bef0d0bbd.svg";
export { ForwardRef as ReactComponent };